import { selectItemSchema } from './schemas/select-item'
import { selectPromotionSchema } from './schemas/select-promotion'
import { viewItemSchema } from './schemas/view-item'
import { viewItemListSchema } from './schemas/view-item-list'
import { viewPromotionSchema } from './schemas/view-promotion'
import { viewSearchResultsSchema } from './schemas/view-search-results'

export const ga4EventSchemas = {
  view_item: viewItemSchema,
  view_item_list: viewItemListSchema,
  select_item: selectItemSchema,
  select_promotion: selectPromotionSchema,
  view_promotion: viewPromotionSchema,
  view_search_results: viewSearchResultsSchema,
}
